module.exports = __webpack_public_path__ + "img/img3.07e6a50b.png";